import styled, { keyframes } from 'styled-components';

import backgroundGradient from 'images/shared-page-assets/background-gradient.svg';

const moveBackground = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export const AnimatedContainer = styled.div`
  position: relative; /* Needed for the pseudo-element */
  width: 100%;
  overflow: hidden; /* Prevents scrollbars during animation */

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 100%;
    background-image: url(${backgroundGradient});
    background-size: cover;
    background-position: center;
    z-index: -1; /* Places the background behind the children */
    animation: ${moveBackground} 6s infinite alternate; /* Animates the background */
  }
`;
